//------------------imports-----------
import React, { useState, useEffect } from "react";
import {
  Grid,
  Container,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Stack,
  Breadcrumbs,
  Link,
  AppBar,
} from "@mui/material";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import { externalpostApi } from "../../services/external/externalApis";
import { useLocation } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import { Slide } from "@mui/material";
import Alert from "@mui/material/Alert";

import {
  SETTINGS_API_09,
  STS,
  CHAINCODE,
  MENUTYPECODE,
} from "../../api/ApiModel";
import { useSelector } from "react-redux";
const names = ["Food Items", "Beverages", "Other Items"];

const ReceiptDetails = () => {
  //---------hooks-----------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [error, setError] = useState({});
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const isEdit = location.state?.actionText === "Edit";

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    RECEIPTDETCODE: "",
    HEADER: "",
    FOOTER: "",
    REFPOLICY: "",
    TERMS: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        RECEIPTDETCODE: String(selectedItem.RECEIPTDETCODE),
        HEADER: selectedItem.HEADER,
        FOOTER: selectedItem.FOOTER,
        REFPOLICY: selectedItem.REFPOLICY,
        TERMS: selectedItem.TERMS,
      });
    }
  }, [selectedItem]);

  //-----------------functions---------------------
  //postapi
  const handleConfirmClick = async () => {
    const { HEADER, FOOTER, REFPOLICY, TERMS } = selectedItemDetails;

    const requiredFields = [
      { name: "HEADER", value: HEADER, label: "Header" },
      { name: "FOOTER", value: FOOTER, label: "Footer" },
      { name: "REFPOLICY", value: REFPOLICY, label: "Refund Policy" },
      { name: "TERMS", value: TERMS, label: "Terms and Conditions" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;
      setSnackbarMessage(errorMessage);
      setOpenErrorSnackbar(true);
      return;
    }

    const receiptcode = selectedItem
      ? String(selectedItem.RECEIPTDETCODE || "")
      : "";

    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      STS: CON_STATUS_ACTIVE,
      LOCDATE: new Date().toISOString(),
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      RECEIPTDETCODE: receiptcode,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_09, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        HEADER: "",
        FOOTER: "",
        REFPOLICY: "",
        TERMS: "",
        RECEIPTDETCODE: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/vreciptdetail");
    }, 2000);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      HEADER: "",
      FOOTER: "",
      REFPOLICY: "",
      TERMS: "",
    });
    setError({});
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };
  //handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    })); // Clear field-specific error on input
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Setting</Link>
                <Link underline="none">Receipt Details</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{ ...styles.AI_fixedStack, justifyContent: "flex-end" }}
              >
                <Button
                  onClick={() => navigate("/vreciptdetail")}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: isEdit ? "Edit Receipt Details" : "Create Receipt Details",
          }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12}>
            <TextField
              label={
                <span>
                  Header Title<span style={{ color: "red" }}> *</span>
                </span>
              }
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="HEADER"
              value={selectedItemDetails.HEADER}
              onChange={handleInputChange}
              error={!!error.HEADER}
              helperText={error.HEADER}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <TextField
              label={
                <span>
                  Footer Title<span style={{ color: "red" }}> *</span>
                </span>
              }
              fullWidth
              size="small"
              variant="outlined"
              autoComplete="off"
              name="FOOTER"
              value={selectedItemDetails.FOOTER}
              onChange={handleInputChange}
              error={!!error.FOOTER}
              helperText={error.FOOTER}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <TextField
              label={
                <span>
                  Refund Policy<span style={{ color: "red" }}> *</span>
                </span>
              }
              fullWidth
              size="small"
              variant="outlined"
              autoComplete="off"
              name="REFPOLICY"
              value={selectedItemDetails.REFPOLICY}
              onChange={handleInputChange}
              error={!!error.REFPOLICY}
              helperText={error.REFPOLICY}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <TextField
              label={
                <span>
                  Terms and Conditions<span style={{ color: "red" }}> *</span>
                </span>
              }
              fullWidth
              size="small"
              variant="outlined"
              autoComplete="off"
              name="TERMS"
              value={selectedItemDetails.TERMS}
              onChange={handleInputChange}
              error={!!error.TERMS}
              helperText={error.TERMS}
            />
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? "Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default ReceiptDetails;
